import React from 'react'
import { useRoutes } from 'react-router-dom'

// UI

//COnstant
import NotFoundPage from '@/components/Page/NotFoundPage'
import UnauthorizedPage from '@/components/Page/UnauthorizedPage'
import PrivateRouteMiddleware from './middlewares/PrivateRouteMiddleware'
import PublicRouteMiddleware from './middlewares/PublicRouteMiddleware'

//Routes

import privateRoutes from './PrivateRoutes/index.jsx'
import publicRoutes from './PublicRoutes'
import allVisibleRoutes from './AllVisibleRoutes'
import MaintenancePage from '@/components/Page/MaintenancePage'
import ExternalRedirectPage from '@/components/Page/ExternalRedirectPage'

const AppRoutes = () => {
  const element = useRoutes([
    {
      path: 'subcontractors/*',
      element: <ExternalRedirectPage />,
    },
    {
      element: <PrivateRouteMiddleware />,
      children: privateRoutes,
    },
    {
      element: <PublicRouteMiddleware />,
      children: publicRoutes,
    },
    ...allVisibleRoutes,

    {
      path: 'unauthorized',
      element: <UnauthorizedPage />,
    },
    {
      breadcrumb: '404',
      path: '*',
      element: <NotFoundPage />,
    },
    {
      path: '/maintenance',
      element: <MaintenancePage />,
    },
  ])

  return <>{element}</>
}

export default AppRoutes
